exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expansion__content[data-v-320f0abc]{max-height:calc(100vh - 170px);overflow:auto;padding:0 10px}\n", ""]);
